import { Injectable } from '@angular/core';
import { io } from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class SocketServiceService {
  observable: Observable<any>;
  socketliq: any;
  socket: any;
  socket_mobile: any;
  envurl = environment.serviceHost

  constructor() {
    this.socket = io(this.envurl, { transports: ['websockets', 'polling'] });
    this.socket_mobile = io(this.envurl, { transports: ['websockets', 'polling'] });
  }

  socket_connect(): any {
    this.socketliq = io(this.envurl, { transports: ['websockets', 'polling'] });
  }

  localSocketConnect(param): any {
    this.socketliq.emit('joinRoom', { message: param });
    this.socket.emit('joinRoom', { message: param });
  }

  leave_socket(param): any {
    this.socketliq.emit('leaveRoom', { message: param });
    this.socket.emit('leaveRoom', { message: param });
  }

  maintenance(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socket.on('under-control', handler);
      return () => this.socket.off('under-control', handler);
    });
  }

  socket_disconnect(): any {
    this.socketliq.disconnect();
  }

  get_trade(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socketliq.on('market-trade-response', handler);
      return () => this.socketliq.off('market-trade-response', handler);
    });
  }

  get_order(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socketliq.on('trade-order-response', handler);
      return () => this.socketliq.off('trade-order-response', handler);
    });
  }

  get_tradeAPI(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socket.on('market-trade-response', handler);
      return () => this.socket.off('market-trade-response', handler);
    });
  }
  online(id): Observable<any> {
    return this.observable = new Observable((observer) => {

      this.socket.emit('new-user-add', { Userid: id });
      // console.log("online",id)
    });
  }
  offline(userid): Observable<any> {
    return this.observable = new Observable((observer) => {

      this.socket.emit('remove-user', { Userid: userid });
      // console.log("offline",userid)

    });
  }
  online_users(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socket.on('get-users', handler);
      return () => this.socket.off('get-users', handler);
    });
  }
  market_price(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socket.on('market-price-data', handler);
      return () => this.socket.off('market-price-data', handler);
    });
  } //open orders

  get_orderAPI(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socket.on('trade-order-response', handler);
      return () => this.socket.off('trade-order-response', handler);
    });
  }  //For Recent Trade

  buy_order(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socketliq.on('buy_order', handler);
      return () => this.socketliq.off('buy_order', handler);
    });
  }

  sell_order(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socketliq.on('sell_order', handler);
      return () => this.socketliq.off('sell_order', handler);
    });
  }
  get_disputes(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socket.on('user-disputes', handler);
      return () => this.socket.off('user-disputes', handler);
    });
  }
  market_order(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socketliq.on('market_order', handler);
      return () => this.socketliq.off('market_order', handler);
    });
  }

  get_Timeout(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socket.on('timeout', handler);
      return () => this.socket.off('timeout', handler);
    });
  }

  getMobile_Timeout(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socket_mobile.on('timeout', handler);
      return () => this.socket_mobile.off('timeout', handler);
    });
  }


  chart_data(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socketliq.on('debth_chart', handler);
      return () => this.socketliq.off('debth_chart', handler);
    });
  }

  chart_data_initial(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socket.on('debth_chart_initiate', handler);
      return () => this.socket.off('debth_chart_initiate', handler);
    });
  }

  acc_block(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socket.on('account_block', handler);
      return () => this.socket.off('account_block', handler);
    });
  }

  ip_block(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socket.on('ip-blocked', handler);
      return () => this.socket.off('ip-blocked', handler);
    });
  }

  get_notification(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socket.on('user-notification', handler);
      return () => this.socket.off('user-notification', handler);
    });
  }
  get_notify(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socket.on('getNotify', handler);
      return () => this.socket.off('getNotify', handler);
    });
  }


  get_PTPOrderMap(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socket.on('emitMapping', handler);
      return () => this.socket.off('emitMapping', handler);
    });
  }

  cancel_order(): Observable<any> {
    return this.observable = new Observable((observer) => {
      const handler = (message) => observer.next(message);
      this.socket.on('cancel-order', handler);
      return () => this.socket.off('cancel-order', handler);
    });
  }


}